<template>
  <JournalCard
    :key="el.id"
    :index="index"
    :el="el"
    :router-to="routerTo"
    :use-block="useBlock"
    no-reverse
    variant="slide"
  />
</template>

<script lang="ts" setup>
  import JournalCard from '@/pages/journal/shared/ui/JournalCard.vue';
  import type { Article } from '@/shared/models/journal';

  defineProps<{
    el: Article;
    index: number;
    useBlock: Function;
    routerTo: string;
  }>();
</script>
